// Health Coin redemption client.
import { API_BASE } from './chat'

export type RewardItem = { id: string; label: string; coin_cost: number; dollar_value: number; type: string }
export type Redemption = { id: number; reward_id: string; label: string; coin_cost: number; status: string; created_at: string }

export async function getRewardsCatalog(): Promise<{ catalog: RewardItem[]; rate: string }> {
  try {
    const r = await fetch(`${API_BASE}/v1/rewards/catalog`)
    return r.ok ? await r.json() : { catalog: [], rate: '' }
  } catch {
    return { catalog: [], rate: '' }
  }
}

export async function getRedemptions(userId: string): Promise<Redemption[]> {
  try {
    const r = await fetch(`${API_BASE}/v1/rewards/redemptions?user_id=${encodeURIComponent(userId)}`)
    return r.ok ? (await r.json()).redemptions : []
  } catch {
    return []
  }
}

export async function redeemReward(userId: string, rewardId: string): Promise<{ ok: boolean; error?: string }> {
  try {
    const r = await fetch(`${API_BASE}/v1/rewards/redeem`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: userId, reward_id: rewardId }),
    })
    if (r.ok) return { ok: true }
    const d = await r.json().catch(() => ({}))
    return { ok: false, error: d.detail || 'Could not redeem.' }
  } catch {
    return { ok: false, error: 'Network error.' }
  }
}
